import { render, staticRenderFns } from "./RankingDesktop.vue?vue&type=template&id=2f0eab96&"
import script from "./RankingDesktop.vue?vue&type=script&lang=js&"
export * from "./RankingDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports